import { format, isToday, isTomorrow, isYesterday, differenceInCalendarDays } from 'date-fns';

export function relativeDate(ts: number | null | undefined): string {
  if (!ts) return '';
  const d = new Date(ts);
  if (isToday(d)) return 'Today';
  if (isTomorrow(d)) return 'Tomorrow';
  if (isYesterday(d)) return 'Yesterday';
  const diff = differenceInCalendarDays(d, new Date());
  if (diff > -7 && diff < 0) return format(d, 'EEEE') + ' (past)';
  if (diff > 0 && diff < 7) return format(d, 'EEEE');
  return format(d, 'MMM d');
}

export function shortDateTime(ts: number | null | undefined): string {
  if (!ts) return '';
  return format(new Date(ts), 'MMM d, h:mm a');
}

export function toInputDate(ts: number | null | undefined): string {
  if (!ts) return '';
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fromInputDate(s: string): number | null {
  if (!s) return null;
  const [y, m, d] = s.split('-').map(Number);
  const dt = new Date(y, m - 1, d, 9, 0, 0);
  return dt.getTime();
}

export function isOverdue(ts: number | null | undefined): boolean {
  if (!ts) return false;
  return ts < Date.now() && !isToday(new Date(ts));
}
